import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=08d06308&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"
import style0 from "./Sort.vue?vue&type=style&index=0&id=08d06308&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d06308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d06308')) {
      api.createRecord('08d06308', component.options)
    } else {
      api.reload('08d06308', component.options)
    }
    module.hot.accept("./Sort.vue?vue&type=template&id=08d06308&scoped=true", function () {
      api.rerender('08d06308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/congroup/Sort.vue"
export default component.exports